import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c39f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { class: "action-bar" }
const _hoisted_3 = { style: {"display":"flex"} }

import { OioPagination, OioForm, OioFormItem, OioRow, OioCol, OioInput, OioButton, OioTag } from '@kunlun/vue-ui-antd';
import { computed, reactive, ref, watch } from 'vue';
import { itemClacEnum, priceTypeEnum } from '../../../../constants/enum';
import ImportDialog from '../../../../components/ImportDialog/ImportDialog.vue';
import AddDialog from './AddDialog.vue';
import { exportModelExcelFile } from '../../../../utils/excel';
import { RuntimeModel } from '@kunlun/dependencies';
import { Modal } from 'ant-design-vue';

interface IProps {
  _dataSource: any[];
  addDataSource: (...args: any[]) => void;
  delDataSource: (...args: any[]) => void;
  updateMerchBill: () => void;
  loading: boolean;
  mountedFlag: boolean;
  rModel: RuntimeModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityPlanTableFieldWidget',
  props: {
    _dataSource: { default: () => [] },
    addDataSource: null,
    delDataSource: null,
    updateMerchBill: null,
    loading: { type: Boolean, default: false },
    mountedFlag: { type: Boolean, default: false },
    rModel: null
  },
  setup(__props: any) {

const props = __props as { _dataSource: any[], addDataSource: (...args: any[]) => void, delDataSource: (...args: any[]) => void, updateMerchBill: () => void, loading: boolean, mountedFlag: boolean, rModel: RuntimeModel }



const tableRef = ref<any>(null);

const displayTableData = computed(() => {
  return state.viewTableData.slice(
    (state.pagination.current - 1) * state.pagination.pageSize,
    state.pagination.current * state.pagination.pageSize
  );
});

const state = reactive({
  dataSource: [] as any[],
  viewTableData: [] as any[],
  pagination: {
    current: 1,
    pageSize: 15
  },
  selectedRows: [] as any[],
  searchForm: {
    merchBillName: '',
    code: '',
    outCode: ''
  }
});

const checkboxChangeEvent = () => {
  state.selectedRows = tableRef.value?.getCheckboxRecords();
};

const handleSearch = () => {
  state.pagination.current = 1;
  state.pagination.pageSize = 15;

  if (Object.entries(state.searchForm).every((i) => !i[1])) {
    initData();
    return;
  }

  // 根据搜索条件过滤数据
  state.viewTableData = props._dataSource.filter((item) => {
    return (
      (item.merchBillName || '').includes(state.searchForm.merchBillName) &&
      (item.code || '').includes(state.searchForm.code) &&
      (item.outCode || '').includes(state.searchForm.outCode)
    );
  });
};

const handleReset = () => {
  state.searchForm.merchBillName = '';
  state.searchForm.code = '';
  state.searchForm.outCode = '';
  initData();
};

const initData = () => {
  state.viewTableData = props._dataSource;
};

const handleAdd = (selectedRows: any[]) => {
  props.addDataSource(selectedRows);
  handleSearch();
};

const handleDel = (delAll = false) => {
  if (delAll) {
    Modal.confirm({
      title: '提示',
      content: '确认执行操作吗？',
      onOk() {
        props.delDataSource(state.selectedRows, delAll);
      }
    });
  } else {
    props.delDataSource(state.selectedRows, delAll);
    handleSearch();
  }
  state.selectedRows = [];
};

const importCallback = (data: any[]) => {
  props.addDataSource(data);
  handleSearch();
};

const handleExport = () => {
  // const includesFields = ['outCode', 'itemNumber', 'name'];
  // const exportModel = cloneDeep(props.rModel);
  // exportModel.modelFields = exportModel.modelFields.filter((i) => includesFields.includes(i.data));
  exportModelExcelFile(props._dataSource, props.rModel, { filename: `方案活动商品明细导出${Date.now()}.xlsx` });
};

// FIXME: 一个字段的修改引发全量更新性能不可接受，只需在提交数据 submit 时更新需要提交的数据即可
watch(
  () => props._dataSource,
  (val) => {
    if (val) {
      handleSearch();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_oio_spin = _resolveComponent("oio-spin")!

  return (_openBlock(), _createBlock(_component_oio_spin, {
    loading: __props.loading,
    style: {"display":"flex","flex-direction":"column","row-gap":"12px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(OioForm), { layout: "horizontal" }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "商品清单名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: state.searchForm.merchBillName,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.searchForm.merchBillName) = $event)),
                          allowClear: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "平台商品编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: state.searchForm.code,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.searchForm.code) = $event)),
                          allowClear: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "ERP商品编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: state.searchForm.outCode,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((state.searchForm.outCode) = $event)),
                          allowClear: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: " " }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioButton), {
                          type: "primary",
                          onClick: handleSearch
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("搜索")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(OioButton), {
                          style: {"margin-left":"12px"},
                          onClick: handleReset
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AddDialog, {
          onAdd: handleAdd,
          model: __props.rModel
        }, null, 8, ["model"]),
        _createVNode(_unref(OioButton), {
          type: "primary",
          disabled: !state.selectedRows.length,
          danger: "",
          onClick: _cache[3] || (_cache[3] = (e) => handleDel())
        }, {
          default: _withCtx(() => [
            _createTextVNode("删除")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(OioButton), {
          type: "primary",
          danger: "",
          onClick: _cache[4] || (_cache[4] = (e) => handleDel(true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("清空表格")
          ]),
          _: 1
        }),
        _createVNode(ImportDialog, {
          label: "商品导入",
          model: __props.rModel,
          "import-template-name": "方案活动商品明细导入模版",
          "import-callback": importCallback
        }, null, 8, ["model"]),
        _createVNode(_unref(OioButton), { onClick: handleExport }, {
          default: _withCtx(() => [
            _createTextVNode("商品导出")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_vxe_table, {
        "header-align": "center",
        border: "",
        ref_key: "tableRef",
        ref: tableRef,
        height: "252",
        size: "mini",
        "column-config": { resizable: true },
        data: _unref(displayTableData),
        "edit-config": { trigger: 'click', mode: 'cell' },
        "scroll-x": { enabled: false },
        "scroll-y": { enabled: true, gt: 10 },
        "checkbox-config": { checkField: 'isSelected', reserve: true },
        onCheckboxChange: _cache[5] || (_cache[5] = () => checkboxChangeEvent()),
        onCheckboxAll: _cache[6] || (_cache[6] = () => checkboxChangeEvent())
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_column, {
            type: "checkbox",
            fixed: "left",
            width: "50",
            align: "center"
          }),
          _createVNode(_component_vxe_column, {
            title: "商品清单名称",
            "edit-render": { autofocus: '.oio-input', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.merchBillName), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input, {
                class: "oio-input",
                value: scope.row.merchBillName,
                "onUpdate:value": ($event: any) => ((scope.row.merchBillName) = $event),
                style: {"width":"100%"},
                onBlur: __props.updateMerchBill
              }, null, 8, ["value", "onUpdate:value", "onBlur"])
            ]),
            _: 1
          }, 8, ["edit-render"]),
          _createVNode(_component_vxe_column, {
            field: "code",
            title: "平台商品编码"
          }),
          _createVNode(_component_vxe_column, {
            field: "outCode",
            title: "ERP商品编码"
          }),
          _createVNode(_component_vxe_column, {
            field: "name",
            title: "商品名称",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "itemNumber",
            title: "货号",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, { title: "价格类型" }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OioTag), { bordered: false }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(priceTypeEnum)[scope.row.priceType]), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            title: "让利/不让利",
            "edit-render": { placeholder: '请点击选择' }
          }, {
            default: _withCtx((scope) => [
              (scope.row.itemCalc)
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(itemClacEnum)[scope.row.itemCalc]), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: scope.row.itemCalc,
                "onUpdate:value": ($event: any) => ((scope.row.itemCalc) = $event),
                "show-search": false,
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                "filter-option": false,
                options: [
              { label: '让利', value: 'DISCOUNT' },
              { label: '不让利', value: 'NOT_DISCOUNT' }
            ]
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            title: "特价价格",
            "edit-render": { autofocus: '.oio-input-number', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.specialPrice), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.specialPrice,
                "onUpdate:value": ($event: any) => ((scope.row.specialPrice) = $event),
                precision: 2,
                style: {"width":"100%"},
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }, 8, ["edit-render"]),
          _createVNode(_component_vxe_column, {
            title: "特价扣率",
            "edit-render": { autofocus: '.oio-input-number', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.specialDiscountRate), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.specialDiscountRate,
                "onUpdate:value": ($event: any) => ((scope.row.specialDiscountRate) = $event),
                precision: 2,
                style: {"width":"100%"},
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }, 8, ["edit-render"]),
          _createVNode(_component_vxe_column, {
            title: "特殊扣率",
            "edit-render": { autofocus: '.oio-input-number', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.specialDeductionRate), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.specialDeductionRate,
                "onUpdate:value": ($event: any) => ((scope.row.specialDeductionRate) = $event),
                precision: 2,
                style: {"width":"100%"},
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }, 8, ["edit-render"]),
          _createVNode(_component_vxe_column, {
            title: "限购数量",
            "edit-render": { autofocus: '.oio-input-number', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.limitBuyNum), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.limitBuyNum,
                "onUpdate:value": ($event: any) => ((scope.row.limitBuyNum) = $event),
                precision: 0,
                style: {"width":"100%"},
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }, 8, ["edit-render"]),
          _createVNode(_component_vxe_column, {
            title: "秒杀库存",
            "edit-render": { autofocus: '.oio-input-number', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.promotionTotalNum), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.promotionTotalNum,
                "onUpdate:value": ($event: any) => ((scope.row.promotionTotalNum) = $event),
                precision: 0,
                style: {"width":"100%"},
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }, 8, ["edit-render"]),
          _createVNode(_component_vxe_column, {
            title: "赠品包装",
            "edit-render": { placeholder: '请点击选择' }
          }, {
            default: _withCtx((scope) => [
              (scope.row.giftPackage)
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.giftPackage), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: scope.row.giftPackage,
                "onUpdate:value": ($event: any) => ((scope.row.giftPackage) = $event),
                "show-search": false,
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                "filter-option": false,
                options: [
              { label: 'KAR', value: 'KAR' },
              { label: 'BX2', value: 'BX2' },
              { label: 'BX1', value: 'BX1' },
              { label: 'PCS', value: 'PCS' }
            ]
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            title: "赠品数量",
            "edit-render": { autofocus: '.oio-input-number', placeholder: '请点击输入' }
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.giftNumber), 1)
            ]),
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.giftNumber,
                "onUpdate:value": ($event: any) => ((scope.row.giftNumber) = $event),
                precision: 0,
                min: 0,
                style: {"width":"100%"},
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }, 8, ["edit-render"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(OioPagination), {
          style: {"margin-left":"auto"},
          current: state.pagination.current,
          "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((state.pagination.current) = $event)),
          pageSize: state.pagination.pageSize,
          "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((state.pagination.pageSize) = $event)),
          pageSizeOptions: [10, 15, 30, 50, 100, 200],
          "show-size-changer": "",
          total: state.viewTableData.length,
          "show-total": (total) => `${total} 条`
        }, null, 8, ["current", "pageSize", "total", "show-total"])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})